export default __webpack_public_path__ + "static/media/Defense Order.9d5669bd.png";